import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-transfer-results",
  "use": "icon-transfer-results-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-transfer-results\"><path d=\"M3.75 10.667H7.5v1.25H3.75v-1.25Zm0-2.5H10v1.25H3.75v-1.25Zm0-2.5H10v1.25H3.75v-1.25Z\" /><path d=\"M8.75 16.917H2.5v-12.5h15v6.25h1.25v-6.25a1.25 1.25 0 0 0-1.25-1.25h-15a1.25 1.25 0 0 0-1.25 1.25v12.5a1.25 1.25 0 0 0 1.25 1.25h6.25v-1.25Z\" /><path d=\"m13.75 16.66-1.619-1.618-.881.881 2.5 2.5 5-5-.881-.881-4.119 4.118Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol